export default __webpack_public_path__ + "static/media/MainPage.ce3a3bfe.txt";